import { getCotizacion } from "../services";
import { useSelector } from 'react-redux'
import { useQuery, useQueryClient } from '@tanstack/react-query'

const ModCotizacion = ({ tipo = "boton" }) => {
    const conta = useSelector((state) => state.conta)

    const { data, refetch, isLoading, isError, isRefetching } = useQuery({
        queryKey: ['cotizacion'],
        queryFn: async (data) => {
            console.log(data);
            const req = await getCotizacion()
            console.log(req)
            return req
        },
        staleTime: 1000 * 60 * 60 * 6, // 5seg
        cacheTime: 1000 * 60 * 60 * 6, // 5seg
        enabled: true,
    });

    return (isLoading || isRefetching) ?
        <p>Loading...</p>
        :
        <>
            {tipo == "header_form" &&
                <div className="ms-auto">
                    <div className="d-flex border-start ms-2">
                        <div className="w-auto p-2 pt-0 pb-0">
                            <h5 className="mb-0 pb-0" style={{ fontSize: "12px" }}><b>COTIZACION</b></h5>
                            <h5 className="mb-0 pb-0" style={{ fontSize: "12px" }}>USD</h5>
                        </div>
                        <div className="w-auto p-2 pt-0 pb-0">
                            <h5 className="mb-0 pb-0" style={{ fontSize: "12px" }}><b>BANK</b></h5>
                            <h5 className="mb-0 pb-0 text-end" style={{ fontSize: "12px" }}>{data?.venta}</h5>
                        </div>
                        <div className="w-auto p-2  pt-0 pb-0">
                            <h5 className="mb-0 pb-0" style={{ fontSize: "12px" }}><b>CASHBOOK</b></h5>
                            <h5 className="mb-0 pb-0 text-end" style={{ fontSize: "12px" }}>{conta.monedas.find(m => m.id == 2).cambio}</h5>
                        </div>
                    </div>
                </div>
            }
            {tipo == "boton" &&
                <div className="custom_bot">

                    <h5 className="w-100m-0 p-0 ps-2 pe-2" style={{ fontSize: "14px" }}>Cotizacion USD</h5>
                    <div className="d-flex ">
                        <div className="w-50 p-2 pt-0">
                            <h5 style={{ fontSize: "12px" }}>BANK</h5>
                            <h5 style={{ fontSize: "12px" }}>{data?.venta}</h5>
                        </div>
                        <div className="w-50 p-2  pt-0">
                            <h5 style={{ fontSize: "12px" }}>CASHBOOK</h5>
                            <h5 style={{ fontSize: "12px" }}>{conta.monedas_object[2].cambio}</h5>
                        </div>
                    </div>
                </div>
            }

            {tipo == "minimized" &&
                    <div className="d-flex gap-2 ">
                            <h5 style={{ fontSize: "12px", padding:0, margin:0 }}>BANK {data?.venta}</h5>
                            <h5 style={{ fontSize: "12px", padding:0, margin:0  }}>CASHBOOK {conta.monedas_object[2].cambio}</h5>
                    </div>
            }
        </>
}

export default ModCotizacion;